import { render, staticRenderFns } from "./base-stack.vue?vue&type=template&id=f9172748"
import script from "./base-stack.vue?vue&type=script&setup=true&lang=js"
export * from "./base-stack.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-stack.vue?vue&type=style&index=0&id=f9172748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports